import { deckConstants } from "../constants/decks"

const initialState = {
  decks: [],
  deck: null,
  allCards: [],
  getDeckFailure: false,
  fetchingDeck: false,
  creatingDeck: false,
  deletingDeck: false,
  decksToAddInLessons: {}
}

export function decksReducer(state = initialState, action) {
  switch (action.type) {
    case deckConstants.ADD_DECK_FAILURE:
      return {
        ...state,
        getDeckFailure: true,
        creatingDeck: false,
        deckFetchError: action.error
      }
    case deckConstants.ADD_DECK_REQUEST:
      return {
        ...state,
        creatingDeck: true
      }

    case deckConstants.ADD_DECK_SUCCESS:
      let updatedDecks = state.decks
      updatedDecks.push(action.change)
      return {
        ...state,
        deck: { ...state.deck, ...action.change },
        decks: updatedDecks,
        creatingDeck: false,
        newDeckCreated: true
      }
    case deckConstants.GET_DECK_FAILURE:
      return {
        ...state,
        getDeckFailure: true,
        fetchingDeck: false,
        deckFetchError: action.error
      }
    case deckConstants.GET_DECK_REQUEST:
      return {
        ...state,
        fetchingDeck: true
      }

    case deckConstants.GET_DECK_SUCCESS:
      return {
        ...state,
        fetchingDeck: false,
        deck: action.deck,
        deckDeleted: false
      }
    case deckConstants.GET_ALL_DECKS_FAILURE:
      return {
        ...state,
        getDeckFailure: true,
        fetchingDeck: false,
        deckFetchError: action.error
      }
    case deckConstants.GET_ALL_DECKS_REQUEST:
      return {
        ...state,
        fetchingDeck: true
      }

    case deckConstants.GET_ALL_DECKS_SUCCESS:
      return {
        ...state,
        fetchingDeck: false,
        decks: action.decks
      }
    case deckConstants.CHANGE_DECK_NAME_FAILURE:
      return {
        ...state,
        updateDeckFailure: true,
        updatingDeckName: false,
        deckFetchError: action.error
      }
    case deckConstants.CHANGE_DECK_NAME_REQUEST:
      return {
        ...state,
        updatingDeckName: true
      }

    case deckConstants.CHANGE_DECK_NAME_SUCCESS:
      return {
        ...state,
        deck: { ...state.deck, ...action.change },
        updatingDeckName: false
      }

    case deckConstants.CHANGE_DECK_CODE_FAILURE:
      return {
        ...state,
        updateDeckFailure: true,
        updatingDeckCode: false,
        deckFetchError: action.error
      }
    case deckConstants.CHANGE_DECK_CODE_REQUEST:
      return {
        ...state,
        updatingDeckCode: true
      }

    case deckConstants.CHANGE_DECK_CODE_SUCCESS:
      return {
        ...state,
        deck: { ...state.deck, ...action.change },
        updatingDeckCode: false
      }
    case deckConstants.CHANGE_DECK_NODE_FAILURE:
      return {
        ...state,
        updateDeckFailure: true,
        updatingDeckNode: false,
        deckFetchError: action.error
      }
    case deckConstants.CHANGE_DECK_NODE_REQUEST:
      return {
        ...state,
        updatingDeckNode: true
      }

    case deckConstants.CHANGE_DECK_NODE_SUCCESS:
      return {
        ...state,
        deck: { ...state.deck, ...action.change },
        updatingDeckNode: false
      }

    case deckConstants.CHANGE_DECK_TAGS_FAILURE:
      return {
        ...state,
        updateDeckFailure: true,
        updatingDeckTags: false,
        deckFetchError: action.error
      }
    case deckConstants.CHANGE_DECK_TAGS_REQUEST:
      return {
        ...state,
        updatingDeckTags: true
      }

    case deckConstants.CHANGE_DECK_TAGS_SUCCESS:
      return {
        ...state,
        deck: { ...state.deck, ...action.change },
        updatingDeckTags: false
      }
    case deckConstants.DELETE_DECK_FAILURE:
      return {
        ...state,
        updateDeckFailure: true,
        deletingDeck: false,
        deckFetchError: action.error
      }
    case deckConstants.DELETE_DECK_REQUEST:
      return {
        ...state,
        deletingDeck: true
      }

    case deckConstants.DELETE_DECK_SUCCESS:
      return {
        ...state,
        deck: { ...state.deck, ...{} },
        deletingDeck: false,

        deckDeleted: true
      }

    case deckConstants.GET_DECK_CARDS_FAILURE:
      return {
        ...state,
        fetchingAllCard: false,
        fetchingAllCardError: action.error
      }
    case deckConstants.GET_DECK_CARDS_SUCCESS:
      return {
        ...state,
        fetchingAllCard: false,
        allCards: action.cards
      }

    case deckConstants.GET_DECK_CARDS_REQUEST:
      return {
        ...state,
        fetchingAllCard: true
      }

    case deckConstants.ADD_DECK_CARDS_FAILURE:
      return {
        ...state,
        addingCardLogic: false,
        addingCardLogicError: action.error
      }
    case deckConstants.ADD_DECK_CARDS_SUCCESS:
      let deckUpdate = { ...state.deck }
      deckUpdate.cards = action.cards
      return {
        ...state,
        addingCardLogic: false,
        allCards: state.allCards.concat(action.cardLogic),
        deck: deckUpdate
      }

    case deckConstants.ADD_DECK_CARDS_REQUEST:
      return {
        ...state,
        addingCardLogic: true
      }

    case deckConstants.EDIT_DECK_CARDS_FAILURE:
      return {
        ...state,
        editingCardLogic: false,
        editingCardLogicError: action.error
      }
    case deckConstants.EDIT_DECK_CARDS_SUCCESS:
      var cardLogics = state.allCards
      cardLogics.forEach(cardLogic => {
        if (cardLogic.id === action.cardLogic.id) {
          cardLogic.name = action.cardLogic.name
          cardLogic.directives = action.cardLogic.directives
          cardLogic.lastModified = action.cardLogic.lastModified
        }
      })
      return {
        ...state,
        editingCardLogic: false,
        allCards: cardLogics
      }
    case deckConstants.EDIT_DECK_CARDS_REQUEST:
      return {
        ...state,
        editingCardLogic: true
      }

    case deckConstants.UPDATE_CARDS_IN_DECK_FAILURE:
      return {
        ...state,
        editingCardsInDeck: false,
        editingCardsInDeckError: action.error
      }
    case deckConstants.UPDATE_CARDS_IN_DECK_SUCCESS:
      deckUpdate.cards = action.cards
      return {
        ...state,
        editingCardsInDeck: false,
        deck: deckUpdate
      }
    case deckConstants.UPDATE_CARDS_IN_DECK_REQUEST:
      return {
        ...state,
        editingCardsInDeck: true
      }

    default:
      return state
  }
}
